import { api } from './request';
import type { GrowthContext } from './growthTracking';
import { getGrowthContext } from './growthTracking';

export type FeedbackType = 'bug' | 'feature' | 'usability' | 'other';

export interface FeedbackValues {
  type: FeedbackType;
  content: string;
  email?: string;
}

export interface FeedbackPayload extends FeedbackValues {
  page: string;
  locale: string;
  sessionId: string;
  utm: GrowthContext['utm'];
}

export function validateFeedback(values: FeedbackValues): Record<string, 'required' | 'invalid'> {
  if (!values.content.trim()) return { content: 'required' };
  if (values.email?.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email.trim())) return { email: 'invalid' };
  return {};
}

export function buildFeedbackPayload(values: FeedbackValues, page: string, context = getGrowthContext()): FeedbackPayload {
  return {
    type: values.type,
    content: values.content.trim().slice(0, 5000),
    ...(values.email?.trim() ? { email: values.email.trim().slice(0, 254) } : {}),
    page: page.slice(0, 255),
    locale: context.locale.slice(0, 16),
    sessionId: context.sessionId.slice(0, 64),
    utm: context.utm,
  };
}

export function submitFeedback(values: FeedbackValues, page: string) {
  const errors = validateFeedback(values);
  if (Object.keys(errors).length) return Promise.reject(errors);
  return api.post<{ accepted: boolean; delivery: 'sent' | 'queued' | 'ignored' }>(
    '/public/feedback',
    buildFeedbackPayload(values, page),
  );
}
